import { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Add as AddIcon, FileDownload as ImportIcon } from '@mui/icons-material';
import { useNodes, useDeleteNode } from '../hooks/useNodes';
import { NodeTable } from '../components/NodeTable';
import { NodeFormDialog } from './NodeFormDialog';
import { ImportNodeDialog } from './ImportNodeDialog';
import type { NodeResponse } from '../api/types';

export function NodesPage() {
  const { data: nodes, isLoading } = useNodes();
  const deleteNode = useDeleteNode();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [importOpen, setImportOpen] = useState(false);
  const [editingNode, setEditingNode] = useState<NodeResponse | null>(null);

  const handleEdit = (node: NodeResponse) => {
    setEditingNode(node);
    setDialogOpen(true);
  };

  const handleDelete = async (node: NodeResponse) => {
    if (window.confirm(`确定删除节点 "${node.name}"？`)) {
      deleteNode.mutate(node.id);
    }
  };

  const handleClose = () => {
    setDialogOpen(false);
    setEditingNode(null);
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" fontWeight={600}>节点管理</Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            variant="outlined"
            startIcon={<ImportIcon />}
            onClick={() => setImportOpen(true)}
          >
            导入节点
          </Button>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setDialogOpen(true)}
          >
            添加节点
          </Button>
        </Box>
      </Box>

      <NodeTable
        nodes={nodes || []}
        isLoading={isLoading}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      <NodeFormDialog
        open={dialogOpen}
        onClose={handleClose}
        editingNode={editingNode}
      />

      <ImportNodeDialog
        open={importOpen}
        onClose={() => setImportOpen(false)}
      />
    </Box>
  );
}
